var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',[_c('v-row',{attrs:{"justify":"space-around"}},[_c('v-col',{staticClass:"pt-8",attrs:{"cols":"12","sm":"8","md":"6","lg":"5","xl":"4"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }